<template>
    <datepicker
        v-bind:config="config"
        v-bind:value="wantedValue"
        v-on:input="update"
        :placeholder="placeholderText"
        ref="timePicker"
    ></datepicker>
</template>



<script>
import Datepicker from 'vue-bulma-datepicker';
import { fullYear, time } from '@utilities/functions';


export default {
    props: {
        value:           { required: true },
        placeholderText: { type: String,  default: '' },
        timeOnly:        { type: Boolean, default: false }
    },


    computed: {
        wantedValue: function () {
            return this.value ? time(this.value) : null;
        },


        config: function () {
            return {
                enableTime: true,
                time_24hr:  true,
                noCalendar: true,
                allowInput: true,
                onClose: function (_, __, fp) {
                    fp.setDate(fp.input.value, true, 'H:i:s');
                },
            }
        },
    },


    methods: {
        update: function (newValue) {
            if (this.value && !this.timeOnly) {
                // 20.12.2018 12:00:00 => 20.12.2018
                let dateAndTime = fullYear(this.value);
                // Adding the time
                dateAndTime += (' ' + newValue + ':00');
                // Emit the `input` event for the v-model of the parent
                this.$emit('input', dateAndTime);

            } else {
                this.$emit('input', newValue + ':00');
            }
        }
    },


    watch: {
        wantedValue: function () {
            if (this.wantedValue === null) {
                this.$refs.timePicker.datepicker.clear();
            }
        }
    },


    components: {
        Datepicker
    }
}
</script>
